<template>
  <div class="container-fluid mt-2">
    <h2>Bericht</h2>
    <div class="btn-toolbar" role="toolbar">
      <div class="btn-group">
        <button @click="saveReport" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <button @click="execReport" class="btn btn-secondary"><font-awesome-icon icon="play"/>&nbsp;Ausführen</button>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <div class="form-group">
          <label>Name</label>
          <input class="form-control" v-model="report.name" type="text">
        </div>
        <div class="form-group">
          <label>Ausgabepfad</label>
          <input class="form-control" v-model="report.output" type="text">
        </div>
        <div class="form-group">
          <label>Ausgabeformat</label>
          <select class="form-control" v-model="report.format">
            <option selected="" value="html">HTML</option>
            <option value="pdf">PDF</option>
            <option value="msword">MS Word</option>
          </select>
        </div>
        <div class="row" v-if="report.format == 'pdf'">
          <div class="col">
            <div class="form-group">
              <label>Papierhöhe (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.paperHeight"/>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Papierbreite (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.paperWidth"/>
            </div>
          </div>
        </div>
        <div class="row" v-if="report.format == 'pdf'">
          <div class="col">
            <div class="form-group">
              <label>Rand Oben (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.marginTop"/>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Rand Unten (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.marginBottom"/>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Rand Rechts (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.marginRight"/>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Rand Links (inch)</label>
              <input type="number" class="form-control" v-model.number="report.pageParams.marginLeft"/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>E-Mail</label>
          <input class="form-control" v-model="report.email" type="text">
          <small class="form-text text-muted">Eine oder mehrere Mails mit Symikolon getrennt z.B. info@test.de;mymail@gmail.com</small>
        </div>
        <div class="form-group">
          <label>Berichtstyp:</label>
          <fieldset class="form-group border">
            <div class="form-check">
              <input class="form-check-input" v-model="report.type" id="rtn" value="0" name="bt" type="radio">
              <label class="form-check-label" for="rtn">Normal</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="report.type" id="rtv" value="1" name="bt" type="radio">
              <label class="form-check-label" for="rtv">Vertreterbericht</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="report.type" id="rtc" value="2" name="bt" type="radio">
              <label class="form-check-label" for="rtc">Kundenbericht</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="report.type" id="rtp" value="3" name="bt" type="radio">
              <label class="form-check-label" for="rtp">Katalog</label>
            </div>
          </fieldset>
        </div>
        <div class="form-group">
          <label>Report-Vorlage:</label>
            <div class="input-group">
              <select class="form-control" v-model="report.template"><option v-for="t in templates" :key="t" :value="t">{{ t }}</option></select>
              <div class="input-group-append">
                <div class="btn-group">
                  <a download :href="'/trendshop.proxy.web/rest/reports/templates/' + encodeURIComponent(report.template)"><button class="btn btn-secondary">Download</button></a>
                  <a download :href="'/trendshop.proxy.web/rest/reports/test/' + encodeURIComponent(report.id)"><button data-toggle="tooltip" data-placement="top" title="HTML / PDF Berichte inklusive Daten" class="btn btn-info">Test-Bericht</button></a>
                  <button @click="openTemplateUpload" class="btn btn-danger">Upload</button>
                </div>
              </div>
            </div>
          <small class="form-text text-muted">Alle Unterordner aus dem Berichts-Verzeichnis (siehe Administration->Konfiguration)</small>
        </div>
        <div class="form-group">
          <label>Letzte Ausführung:</label>
          <input disabled="" type="text" v-model="report.lexec" class="form-control">
        </div>
      </div>
    </div>
    <div class="container" style="min-height:300px;">
      <b-tabs content-class="mt-3">
        <b-tab title="Planung">
          <CronExprBuilder ref="cron"/>
        </b-tab>
        <b-tab title="Datenquellen">
          <div class="row">
            <small class="form-text text-muted">Einbindung in die Vorlage via &lt;script src="{name}.js"&gt;&lt;/script&gt;. Daten-Varialbe = {name}</small>
            <div class="btn-toolbar mt-2 justify-content-between btn-block" role="toolbar">
              <div class="btn-group" v-for="(_,key) in report.datasource" :key="key" role="group">
                <button @click="selectReportTable(key)" class="btn btn-secondary">{{ key }}</button>
                <button @click="deleteReportTable(key)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
              </div>
              <div class="input-group" role="group">
                <select v-model="temptable" class="form-control">
                  <option value="">Neue Tabelle</option>
                  <option v-for="t in systables" :key="t.name" :value="t.name">{{ t.name }}</option>
                </select>
                <input class="form-control" placeholder="Name" type="text" v-model="newName"/>
                <div class="input-group-append">
                  <button @click="addReportTable" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="subtables" class="row mt-3">
            <MultiTableSource ref="msource" @delete="deleteTable" @edit="openTable" :sources="sources" :tables="subtables" v-show="!editMode"/>
            <DataTableEditor @save="submitTable" :table="editTable" :source="editSource" v-show="editMode"/>
          </div>
        </b-tab>
        <b-tab title="Parameter">
          <ReportParamView :params="report.params"/>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal id="tempUpload" title="Vorlage hochladen" @ok="uploadTemplate">
      <div class="form-group">
        <label>Report-Vorlage aktualisieren oder neu einbinden:</label>
        <input v-model="tempuplName" placeholder="Name / Titel" type="text" class="form-control"/>
      </div>
      <div class="form-check-group">
        <input id="tempOverwrite" type="checkbox" v-model="tempuplOverwrite" class="form-check-control">
        <label for="tempOverwrite">Vorlage &uuml;berschreiben</label>
      </div>
      <div class="form-group">
        <label>ZIP-Vorlage:</label>
        <input ref="tempuplFile" type="file" class="form-control-file">
      </div>
    </b-modal>
  </div>
</template>

<script>
import reports from '@/modules/reports.js'
import datamap from '@/modules/datamap.js'
import CronExprBuilder from '@/components/CronExprBuilder.vue'
import ReportParamView from '@/components/reports/ReportParamView.vue'
import MultiTableSource from '@/components/genericdata/MultiTableSource.vue';
import DataTableEditor from '@/components/genericdata/DataTableEditor.vue'

export default {
  name: 'ReportEditor',
  components: {
    CronExprBuilder,
    ReportParamView,
    DataTableEditor,
    MultiTableSource,
  },
  data() {
    return {
      reportid: -1,
      report: {},
      templates: [],
      subtables: false,
      sources: [],
      editMode: false,
      editTable: {},
      editSource: {},
      newName: "",
      systables: [],
      temptable: '',
      tempuplName: '',
      tempuplOverwrite: false,
    }
  },
  created: function() {
    var self = this;
    // get datasources
    datamap.listsources(this,0,100,function(data) {
      self.sources = data;
    })
    datamap.listtables(this,0,500,'name','',function(data) {
      self.systables = data;
    })
    // get report
    this.reportid = this.$route.params.reportid;
    reports.templates(function(data) {
      self.templates = data;
      if (self.reportid == 'new') {
        self.report = { id: 0,datasource: {},cron: '',type:0,output:'',email:'', params: {} };
      } else {
        self.fetchData();
      }
    });
  },
  methods: {
    downloadTestReportHTML() {
      console.log('download test report');
    },
    uploadTemplate(e) {
      if (!this.tempuplName || this.tempuplName == '') {
        this.$bvToast.toast('Bitte zuerst einen Namen angeben.',{title: 'Upload', variant: 'warning'});
        e.stopPropagation();
        return;
      }
      if (this.$refs.tempuplFile.files.length == 0) {
        this.$bvToast.toast('Bitte zuerst eine ZIP Datei auswählen.',{title: 'Upload', variant: 'warning'});
        e.stopPropagation();
        return;
      }

      var tfile = this.$refs.tempuplFile.files[0];

      var self = this;
      reports.updateTemplate(this.tempuplName,tfile,this.tempuplOverwrite).then(function() {
          self.$bvToast.toast('Vorlage übernommen',{title: 'Upload', variant: 'success'});
          reports.templates(function(data) {
            self.templates = data;
          });
      }).catch(function (err) {
        console.error(err);
        self.$bvToast.toast('Fehler beim Upload',{title:'Vorlagen',variant:'danger'});
      });

    },
    openTemplateUpload(e) {
      this.$bvModal.show('tempUpload');
      e.stopPropagation();
    },
    saveReport: function() {
      var self = this;
      this.report.cron = this.$refs.cron.cron;
      reports.save(this,this.report,function(data) {
        if (data.id) self.report.id = data.id;
        self.$bvToast.toast('Bericht gespeichert.',{title: 'Berichte',variant: 'success'});
      })
    },
    execReport: function() {
      var self = this;
      reports.execute(this,this.report.id,false,function() {
        self.$bvToast.toast('Bericht wurde gestartet.',{title: 'Berichte',variant: 'success'});
      })
    },
    openTable: function(idx) {
      this.editTable = this.$refs.msource.tables[idx].table;
      this.editSource = this.$refs.msource.tables[idx].datasource;
      this.editMode = true;
      if (this.editSource.refid) this.editSource.type = 'referer';
    },
    deleteTable: function(idx) {
      this.tables.splice(idx,1);
    },
    submitTable: function() {
      this.editMode = false;
    },
    deleteReportTable: function(name) {
      if (confirm('Berichtstabelle wirklich löschen (' + name + ')?')) {
        delete this.report.datasource[name];
        this.$forceUpdate();
      }
    },
    selectReportTable: function(name) {
      if (Array.isArray(this.report.datasource[name])) {
        this.subtables = this.report.datasource[name];
      } else {
        this.subtables = false;
        this.temptable = this.report.datasource[name];
      }
      this.editMode = false;
    },
    addReportTable: function() {
      if (this.newName == '') {
        this.$bvToast.toast('Bitte eine Namen eingeben!',{title:'Tabellen',variant: 'warning'});
        return;
      }
      if (this.report.datasource[this.newName]) {
        this.$bvToast.toast('Name ist bereits vergeben.',{title:'Tabellen',variant: 'warning'});
      }
      if (this.temptable === '') {
        this.report.datasource[this.newName] = [];
      } else {
        this.report.datasource[this.newName] = this.temptable;
      }
      this.$forceUpdate();
    },
    fetchData: function() {
      var self = this;
      reports.load(this.reportid,function(data) {
        if (!data.pageParams) 
          data.pageParams = {};
        self.report = data;
        self.$refs.cron.cron = data.cron;
      })
    }
  }
}
</script>
